<template>
	<div v-editable="blok" class="flex gap-1 text-sm items-center uppercase">
		<span class="lg:pb-[15px]">
			<nuxt-link
				:to="link"
				class="nav-link nav-link-cms lg:pb-[15px] lg:hover:border-b-2 lg:hover:-mb-[2px] lg:hover:border-secondary"
				:class="blok.color || ''"
				@click="closeMobileMenu"
			>
				{{ blok.name }}
			</nuxt-link>
		</span>
	</div>
</template>

<script setup lang="ts">
import type { BlokMenuLink } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokMenuLink;
}
const { blok } = defineProps<Props>();

const localePath = useLocalePath();
const link = computed(() => {
	return localePath("/" + blok?.link?.story?.full_slug);
});

const emit = defineEmits(["closeMobileMenu"]);
const closeMobileMenu = () => {
	emit("closeMobileMenu");
};
</script>
